import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sybase.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Sybase_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Sybase_DisplayText)
    ]
})
export class SybaseLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName
    })
    public database?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
